module.exports = __webpack_public_path__ + "media/images/logo-black-69e82586b32032e63e7c0365d7407abe.svg";